import { Cable } from 'lucide-react'
import { FC } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { z } from 'zod'

import { zodResolver } from '@hookform/resolvers/zod'

import Field from '@/components/field'
import LoadingButton from '@/components/loading-button'
import { FormProps } from '@/pages/settings/single-sign-on'
import { DialogFooter } from '@/components/ui/dialog'

const schema = z
  .object({
    discoveryUrl: z.string().url({ message: 'Discovery URL is required' }),
    domain: z.string().min(1, { message: 'Domain is required' }),
    clientId: z.string().min(1, { message: 'Client ID is required' }),
    clientSecret: z.string().min(1, { message: 'Client Secret is required' }),
  })
  .required()

type FormData = z.infer<typeof schema>

type Props = FormProps<'oidc'>

const OIDCForm: FC<Props> = ({ timer, onSetup }) => {
  const form = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      discoveryUrl: '',
      domain: '',
      clientId: '',
      clientSecret: '',
    },
    mode: 'onChange',
  })

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSetup)}>
        <div className="flex flex-col gap-4">
          <Field<FormData>
            label="OpenID Discovery URL"
            name="discoveryUrl"
            placeholder="https://example.com/.well-known/openid-configuration"
          />

          <Field<FormData>
            label="Email domain"
            name="domain"
            hint="If your company email addresses are name@example.com, this value should be example.com"
          />

          <Field<FormData> label="Client ID" name="clientId" placeholder="Enter your client ID" />

          <Field<FormData> label="Client Secret" name="clientSecret" placeholder="Enter your client secret" />
        </div>

        <DialogFooter>
          <LoadingButton timer={timer} type="submit" className="w-full">
            <Cable className="w-4 h-4 mr-2" />
            Connect OIDC IDP
          </LoadingButton>
        </DialogFooter>
      </form>
    </FormProvider>
  )
}

export default OIDCForm
